"use client";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { DropdownMenu } from "@radix-ui/themes";
import * as React from "react";
import { DeleteUserDialog } from "./delete-user-dialog";
import { EditUserRoleDialog } from "./edit-user-role-dialog";
import { DestructiveMenuItem, DropdownMenuContent, PrimaryMenuItem, } from "./elements";
import { ResendInviteDialog } from "./resend-invite-dialog";
import { RevokeInviteDialog } from "./revoke-invite-dialog";
import { useRoles } from "../api";
export const UserActionsDropdown = ({ user, children, }) => {
    const rolesQuery = useRoles({
        query: {
            initialData: [],
        },
    });
    const [openDialog, setOpenDialog] = React.useState(null);
    /**
     * Assigns a key for each dialog based on its open state to ensure its
     * internal state is cleared when it is closed.
     */
    function getDialogKey(dialog) {
        return `${dialog}-${openDialog === dialog}-${user.id}`;
    }
    const { actions, items } = React.useMemo(() => {
        const actions = new Set(user.actions);
        const items = [];
        if (actions.has("edit-role")) {
            items.push(_jsx(PrimaryMenuItem, { onSelect: () => setOpenDialog("edit-role"), disabled: rolesQuery.isLoading ||
                    (rolesQuery.isSuccess && rolesQuery.data.length <= 1), title: rolesQuery.isSuccess && rolesQuery.data.length <= 1
                    ? "You cannot update the role for this user as there is only one role available."
                    : undefined, children: "Edit role" }, "edit-role"));
        }
        if (actions.has("resend-invite")) {
            items.push(_jsx(PrimaryMenuItem, { onSelect: () => setOpenDialog("resend-invite"), children: "Resend invitation" }, "resend-invite"));
        }
        if (actions.has("revoke-invite")) {
            items.push(_jsx(DestructiveMenuItem, { onSelect: () => setOpenDialog("revoke-invite"), children: "Revoke invitation" }, "revoke-invite"));
        }
        if (actions.has("revoke-membership")) {
            items.push(_jsx(DestructiveMenuItem, { onSelect: () => setOpenDialog("revoke-membership"), children: "Remove user" }, "revoke-membership"));
        }
        return {
            actions,
            items,
        };
    }, [rolesQuery, user.actions]);
    if (user.isLoggedInUser || items.length === 0) {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs(DropdownMenu.Root, { children: [_jsx(DropdownMenu.Trigger, { children: children }), _jsx(DropdownMenuContent, { size: "2", align: "end", children: items })] }), actions.has("edit-role") && (_jsx(EditUserRoleDialog, { user: user, open: openDialog === "edit-role", onOpenChange: (open) => !open && setOpenDialog(null) }, getDialogKey("edit-role"))), actions.has("revoke-membership") && (_jsx(DeleteUserDialog, { user: user, open: openDialog === "revoke-membership", onOpenChange: (open) => !open && setOpenDialog(null) }, getDialogKey("revoke-membership"))), actions.has("revoke-invite") && (_jsx(RevokeInviteDialog, { user: user, open: openDialog === "revoke-invite", onOpenChange: (open) => !open && setOpenDialog(null) }, getDialogKey("revoke-invite"))), actions.has("resend-invite") && (_jsx(ResendInviteDialog, { user: user, open: openDialog === "resend-invite", onOpenChange: (open) => !open && setOpenDialog(null) }, getDialogKey("resend-invite")))] }));
};
//# sourceMappingURL=user-actions-dropdown.js.map